export const enum ConfigId {
  Care = 'care',
}
